$(document).on("turbolinks:load", () => {

    $("#changeApiKey").click(function(e){
      $.get("/generate_api_key", function(data){
        $("#apiKey").val(data);
      });
      e.preventDefault();
    });

    $("#changeStripeCustomer").click(function(e){

      $.ajax({
        type: "Get",
        url: "/generate_stripe_customer",
        data: {
          "id": $("#villageId").val(),
          "email": $("#stripeCustomerEmail").val()
        },
        success: function(data) {
          $("#stripeCustomerId").val(data);
        },
      });
      e.preventDefault();
    });
  })